import { agreementBlocks } from "../shared/agreementFields";

// A filled-in text agreement as the customer reads it: paragraphs, the units table, and a
// "Sign here" box where {{signature}} is. Same blocks as the signed PDF (see worker/esign-pdf.js).
export function AgreementText({ text, style }) {
  return (
    <div style={{ fontSize: 14, lineHeight: 1.6, ...style }}>
      {agreementBlocks(text).map((b, i) => {
        if (b.type === "table") {
          const [head, ...rows] = b.rows;
          return (
            <div key={i} className="tw" style={{ margin: "6px 0 10px" }}><table>
              <thead><tr>{head.map((c, j) => <th key={j}>{c}</th>)}</tr></thead>
              <tbody>{rows.map((r, k) => (
                <tr key={k} style={/^total/i.test(r[0] || "") ? { fontWeight: 700 } : undefined}>
                  {r.map((c, j) => <td key={j} style={/^£/.test(c) ? { textAlign: "right", whiteSpace: "nowrap" } : undefined}>{c}</td>)}
                </tr>
              ))}</tbody>
            </table></div>
          );
        }
        if (b.type === "business_signature") {
          return <div key={i} style={{ width: 280, maxWidth: "100%", height: 64, margin: "6px 0", border: "2px dashed #C9D8E8", background: "#F8FAFC", borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, color: "var(--sub)", textAlign: "center", padding: 6 }}>Signed for the business after you</div>;
        }
        if (b.type === "signature") {
          return <div key={i} style={{ width: 280, maxWidth: "100%", height: 64, margin: "6px 0", border: "2px dashed #E8B931", background: "#FFF8E6", borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, color: "#7A5600" }}>✍️ Sign here</div>;
        }
        return <div key={i} style={{ whiteSpace: "pre-wrap" }}>{b.text}</div>;
      })}
    </div>
  );
}
